import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TextEditerPage } from './text-editer';

@NgModule({
  declarations: [TextEditerPage],
  imports: [IonicPageModule.forChild(TextEditerPage)],
})
export class TextEditerPageModule {}



// WEBPACK FOOTER //
// ./src/pages/text-editer/text-editer.module.ts